import { getApiEnvironment, runtimeEnvironment, API_ENVIRONMENT_LABELS } from '@/config';

export const ApiEnvironmentBadge = () => {
    const apiEnv = getApiEnvironment();
    const runtime = runtimeEnvironment();

    if (apiEnv === runtime) return null;

    const label = API_ENVIRONMENT_LABELS[apiEnv] ?? apiEnv;

    return (
        <div
            className="c-api-env-badge"
            title={`API peker mot ${label} (runtime: ${runtime})`}
        >
            API-miljø: {label}
        </div>
    );
};
